// ABOUTME: Day navigation header for the calendar with prev/next arrows and Today button.
// ABOUTME: Shows clear visual indicator when viewing a date other than today.

import { Box, IconButton, Typography, Button } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TodayIcon from '@mui/icons-material/Today';
import { format, addDays, subDays } from 'date-fns';

interface DayCalendarNavProps {
  date: Date;
  onDateChange: (date: Date) => void;
  onToday: () => void;
  isToday: boolean;
}

export function DayCalendarNav({ date, onDateChange, onToday, isToday }: DayCalendarNavProps) {
  const handlePrev = () => {
    onDateChange(subDays(date, 1));
  };

  const handleNext = () => {
    onDateChange(addDays(date, 1));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        py: 0.5,
        px: 1,
        borderRadius: 1,
        bgcolor: isToday ? 'transparent' : 'warning.light',
        transition: 'background-color 0.2s',
      }}
    >
      <IconButton size="small" onClick={handlePrev} aria-label="Previous day">
        <ChevronLeftIcon fontSize="small" />
      </IconButton>

      <Typography
        variant="body2"
        sx={{
          fontWeight: isToday ? 400 : 600,
          minWidth: 100,
          textAlign: 'center',
        }}
      >
        {format(date, 'EEE, MMM d')}
      </Typography>

      <IconButton size="small" onClick={handleNext} aria-label="Next day">
        <ChevronRightIcon fontSize="small" />
      </IconButton>

      {!isToday && (
        <Button
          size="small"
          variant="outlined"
          startIcon={<TodayIcon />}
          onClick={onToday}
          sx={{ ml: 0.5, textTransform: 'none', fontSize: '0.75rem' }}
        >
          Today
        </Button>
      )}
    </Box>
  );
}
